import { ArrowPathIcon } from "@heroicons/react/24/outline"
import React from "react"

import { ButtonLink } from "../../../components/shared/Links"

import { authorizeUrl, migratableLegacyConnection, providerLabel } from "./selectors"
import { CalendarConnectionSummary, CalendarProvider } from "./types"

interface Props {
  connection: CalendarConnectionSummary
  connectableProviders: CalendarProvider[]
}

// Upgrade prompt for a legacy Cronofy connection that can move to native
// sync. The OAuth link carries this connection's public id so the backend can
// sign the migration linkage — the destination is never inferred from
// provider/email matching.
const ReconnectLegacyBanner = ({ connection, connectableProviders }: Props) => {
  if (!migratableLegacyConnection(connection, connectableProviders)) return null

  const reconnectUrl = authorizeUrl(connection.provider, {
    legacyConnectionPublicId: connection.publicId,
    reconsent: true
  })
  if (!reconnectUrl) return null

  return (
    <div className="mt-3 flex flex-wrap items-center gap-3 rounded-lg border border-teal bg-teal/5 p-3">
      <ArrowPathIcon className="size-5 flex-none text-teal" aria-hidden="true" />
      <div className="min-w-0 flex-1 text-sm">
        Upgrade this {providerLabel(connection.provider)} connection to Heal.me&apos;s new sync. Your events and
        bookings move over automatically.
      </div>
      <ButtonLink href={reconnectUrl} variant="secondary" className="">
        Upgrade connection
      </ButtonLink>
    </div>
  )
}

export default ReconnectLegacyBanner
